import { useTranslation } from 'react-i18next';
import type { Partner } from '../../api.js';

interface PartnersTableProps {
  partners: Partner[];
  busy: boolean;
  onSelect: (id: string) => void;
}

export function PartnersTable({ partners, busy, onSelect }: PartnersTableProps) {
  const { t } = useTranslation();
  return (
    <div className="panel">
      <h2>{t('partners.title')}</h2>
      <table className="data-table">
        <thead>
          <tr>
            <th>{t('partners.name')}</th>
            <th>{t('partners.slug')}</th>
            <th>{t('partners.tenantCap')}</th>
            <th>{t('partners.status')}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {partners.map((partner) => (
            <tr key={partner.id}>
              <td>{partner.name}</td>
              <td>{partner.slug}</td>
              <td>{partner.tenantCap ?? t('partners.unlimited')}</td>
              <td>{partner.status}</td>
              <td>
                <button onClick={() => onSelect(partner.id)} disabled={busy}>
                  {t('partners.manage')}
                </button>
              </td>
            </tr>
          ))}
          {partners.length === 0 && (
            <tr>
              <td colSpan={5} className="muted">
                {t('partners.none')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
